import React from "react";
import { Button, Modal, Tag } from "antd";
import { useTranslation } from "react-i18next";
import Table, { ColumnsType } from "antd/lib/table";
import { parseISO } from "date-fns";
import { IRequirement } from "../../Project";
import ProjectStatus from "../../../enums/ProjectStatus";
import ActivityStatus from "../../../enums/ActivityStatus";
import { IUser } from "../../Users";
import UserAvatar from "../../../components/UserAvatar";

interface IActionHistoryItem {
  id: string;
  old_status: ProjectStatus | ActivityStatus;
  new_status: ProjectStatus | ActivityStatus;
  object_type: "PROJECT" | "ACTIVITY";
  object_id: string;
  reason?: string;
  user_id: string;
  assigned_user_id?: string;
  created_at: Date;
}

interface IActivityActionsHistoryModalProps {
  activity?: IRequirement;
  visible: boolean;
  handleClose: () => void;
}

const ActivityActionsHistoryModal: React.FC<IActivityActionsHistoryModalProps> = ({
  activity,
  visible,
  handleClose,
}) => {
  const { t } = useTranslation(["activities"]);

  const actionsHistoryColumns: ColumnsType<IActionHistoryItem> = [
    {
      title: t("date"),
      dataIndex: "created_at",
      render: date =>
        date &&
        `${parseISO(date).toLocaleDateString("pt-BR")} às ${parseISO(
          date,
        ).toLocaleTimeString("pt-BR")}`,
    },
    {
      title: t("user"),
      dataIndex: "user",
      render: (creator: IUser) => {
        if (creator) {
          return (
            <UserAvatar
              name={creator.name}
              url={creator.avatar_url}
              size={36}
            />
          );
        }
        return <></>;
      },
    },
    {
      title: t("old_status"),
      dataIndex: "old_status",
      render: (old_status: string) => {
        return (
          <Tag color={t(`status.options.${old_status}.color`)}>
            {t(`status.options.${old_status}.label`)}
          </Tag>
        );
      },
    },
    {
      title: t("new_status"),
      dataIndex: "new_status",
      render: (new_status: string) => {
        return (
          <Tag color={t(`status.options.${new_status}.color`)}>
            {t(`status.options.${new_status}.label`)}
          </Tag>
        );
      },
    },
    {
      title: t("assigned_user"),
      dataIndex: "assigned_user",
      render: (assigned: IUser) => {
        if (assigned) {
          return (
            <UserAvatar
              name={assigned.name}
              url={assigned.avatar_url}
              size={36}
            />
          );
        }
        return <></>;
      },
    },
  ];

  return (
    <Modal
      title={t("actions_history")}
      visible={visible}
      destroyOnClose
      width={800}
      onCancel={() => handleClose()}
      getContainer={false}
      footer={[
        <Button type="primary" key="ok" onClick={() => handleClose()}>
          Ok
        </Button>,
      ]}
    >
      <Table
        dataSource={activity?.actionsHistory || []}
        rowKey={record => record.id}
        columns={actionsHistoryColumns}
        pagination={false}
        size="small"
      />
    </Modal>
  );
};

export default ActivityActionsHistoryModal;
